export default {"src":"/_next/static/media/Lock.5044115f.svg","height":64,"width":48,"blurWidth":0,"blurHeight":0};